import { styled } from "styled-components";

export const DropdownSelect = styled.select`
  padding: 5px;
  width: 120px;
  height: 40px;
  font-size: 18px;
  margin-right: 25px;
`;
